import React from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as audio } from 'icons/mediaTypes/icon-audio.svg';
import { ReactComponent as video } from 'icons/mediaTypes/icon-video.svg';

const StyledIcon = styled.svg`
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
`;

const SmallStyledIcon = styled.svg`
  width: 1.2rem;
  min-width: 1.2rem;
  height: 1.2rem;
  margin-left: -0.3rem;
  margin-top: 0.2rem;
`;

interface IMediaIconProps {
  mediaType: string;
  showHiddenPlaceholder?: boolean;
  small?: boolean;
}

const MediaIcon: React.FC<IMediaIconProps> = (props) => {
  const { mediaType, showHiddenPlaceholder, small } = props;

  const icons = {
    audio,
    video,
  };

  const mediaName = mediaType.toLowerCase().replace(/\s/g, '');

  const hasNoIcon = mediaName in icons === false;
  if (hasNoIcon && showHiddenPlaceholder) return <StyledIcon as="div" />;
  if (hasNoIcon) return null;

  const iconComponent = mediaName === 'audio' ? audio : video;

  return small ? (
    <SmallStyledIcon as={iconComponent} />
  ) : (
    <StyledIcon as={iconComponent} />
  );
};

export default MediaIcon;
